import { render, staticRenderFns } from "./disabledGoods.vue?vue&type=template&id=62d0c21a&scoped=true&"
import script from "./disabledGoods.vue?vue&type=script&lang=js&"
export * from "./disabledGoods.vue?vue&type=script&lang=js&"
import style0 from "./disabledGoods.vue?vue&type=style&index=0&id=62d0c21a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d0c21a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
